export const installmentsActivation = {
    consents: [
        {
            id: 'consent-1',
            translationKey: 'cards.components.installmentsActivation.configurationPage.consent1',
        },
        {
            id: 'consent-2',
            translationKey: 'cards.components.installmentsActivation.configurationPage.consent2',
        },
    ],
};
